import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, authReady, justLoggedOut } = useAuth();

  if (!authReady) {
    return <div>Loading...</div>;
  }

  if (!isLoggedIn) {
    return <Navigate to={justLoggedOut ? '/' : '/login'} replace />;
  }

  return children;
};

export default ProtectedRoute;
